import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RecommTable from './RecommTable';
import TextOrMdash from './TextOrMdash';
import DisplayFoto from './DisplayFoto';
import DeEscapeTxt from "./DeEscapeTxt";
  
function PrevPovrch(props: any) {
    const { keycloak, initialized } = useKeycloak();
    const navigate = useNavigate();
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    //console.log("PrevPovrch.tsx - viditelnost from Redux")
    //console.log(viditelnost)
    //
    return (
        <tr className='itemRow' key={props.povrch.id} onClick={() => navigate('/povrchy/povrch/' + props.povrch.id)}>
            <td><TextOrMdash text={DeEscapeTxt(props.povrch.kod)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.povrch.nazev)}/></td>
            {(typeof (props.povrch.foto) !== 'undefined' && props.povrch.foto != null)
                ? <td width={"300px"}><div>{props.povrch.foto.map((foto: any)=> <DisplayFoto key={foto.fotoId} foto={foto}/>)}</div></td>
                : <td>&mdash;</td>}
            <td>{(typeof (props.povrch.povrchyPouziti) !== 'undefined' && props.povrch.povrchyPouziti != null)
                    ? <RecommTable recommendations={props.povrch.povrchyPouziti} />
                    : <div>&mdash;</div>}
            </td>
            <td><TextOrMdash text={DeEscapeTxt(props.povrch.podminkaobecna)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.povrch.popis)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.povrch.naslapnavrstva_v)}/></td>
            <td><TextOrMdash text={props.povrch.datumeditace}/></td>
            {keycloak.authenticated && (
            <td>{(typeof (viditelnost) !== 'undefined' && viditelnost != null && viditelnost.length != 0)
                ? <TextOrMdash text={viditelnost.find((vid: any)=>vid.key===props.povrch.viditelnost).value} />
                : <div>&mdash;</div>}</td>
            )}
        </tr>)
}
export default PrevPovrch